// extracted by mini-css-extract-plugin
export default {"image-link":"image-link--1-TAQ","error":"error--1kaRm"};